const contextEnrichment = ({
    currency,
    isTouch,
    page_ctx_id,
    boxClass,
    carouselPosition,
    gigCollect
}) => ({
    gigCollect: {
        currentUser: {},
        showCollMenu: false,
        ...gigCollect
    },
    impressionEnrichment: {
        listings: {
            carousel_position: carouselPosition.toString(),
            page_ctx_id
        }
    },
    context: {
        sourcePage: 'guest_homepage',
        sourceComponent: boxClass,
        currency,
        pageCtxId: page_ctx_id,
        queryParameters: {
            context: 'recommendation'
        },
        viewportType: 'homepage.logged_out',
        controllerAction: 'homepage#logged_out'
    },
    isTouch
});

export default contextEnrichment;
